import React from "react";

const FreeTrialModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="free-trial-overlay">
      <div className="free-trial-modal">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>

        <div className="trail-badge">🚀 Free Trial Access</div>

        <h2 className="modal-title">Try AI Recruiter for Free</h2>

        <p className="modal-subtitle">
          Experience our powerful AI Resume Screening tool with a{" "}
          <strong>limited free trial</strong>.
        </p>

        <div className="email-card">
          <span>Request Access:</span>
          <a
            href="mailto:contactus@archipeltechnologies.com?subject=Free Trial Request - AI Recruiter"
            className="email-link"
          >
            contactus@archipeltechnologies.com
          </a>
        </div>

        <p className="modal-footer">
          Our team will activate your free trial within 24 hours 💼✨
        </p>
      </div>
    </div>
  );
};

export default FreeTrialModal;
